// extracted by mini-css-extract-plugin
module.exports = {"enter":"slideUp_enter__8b6Rq","enterActive":"slideUp_enterActive__jHjJN","exit":"slideUp_exit__acKrH","exitActive":"slideUp_exitActive__x_7p3"};